import React, { useEffect, useMemo, useState } from "react";
import Header from "../component/Header";
import TextField from "../component/Partial/TextField";
import Button from "../component/Partial/Button";
import SelectField from "../component/Partial/SelectField";
import Tabs from "../component/Tabs/Tabs";
import EditIcon from "../assets/Icons/EditIcon";
import DeleteIcon from "../assets/Icons/DeleteIcon";
import { Link } from "react-router-dom";
import { ROTUES } from "../utils/global";
import { useDispatch, useSelector } from "react-redux";
import {
  createSection,
  fetchProjectById,
  fetchRoomsByProject,
  fetchSectionsByProject,
  fetchTouchesByProject,
  updateProjectAction,
} from "../store/actions/projectAction";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import Sections from "../component/Tabs/Sections";
import Rooms from "../component/Tabs/Rooms";
import AddRooms from "./AddRooms";
import Touches from "../component/Tabs/Touches";
import AddTouches from "./AddTouches";



function Dashboard() {
  const dispatch = useDispatch();
  const params = useParams();

  const [activeTab, setActiveTab] = useState("Touch Switch");
  const [projectDetails, setProjectDetails] = useState(null);
  const [isEditingName, setIsEditingName] = useState(false);
  const [newProjectName, setNewProjectName] = useState("");

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (params?.id) {
      dispatch(fetchSectionsByProject(params?.id));
      dispatch(fetchRoomsByProject(params?.id));
      dispatch(fetchTouchesByProject(params?.id));

      dispatch(fetchProjectById(params?.id))
        .unwrap()
        .then((data) => {
          setProjectDetails(data?.doc);
          setNewProjectName(data?.doc?.name || "");
        });
    }
  }, []);

  const handleCreateSectionButtonClicked = ({ section_name }) => {
    dispatch(
      createSection({
        name: section_name,
        projectId: params?.id,
      })
    ).then(() => {
      setValue("section_name", "");
    });
  };

  const handleEditProjectName = () => {
    setIsEditingName(true);
  };

  const handleSaveProjectName = () => {
    if (newProjectName.trim() && newProjectName !== projectDetails?.name) {
      dispatch(
        updateProjectAction({
          id: params?.id,
          name: newProjectName
        })
      ).unwrap()
        .then(() => {
          // Update local state to reflect the change
          setProjectDetails({
            ...projectDetails,
            name: newProjectName
          });
          setIsEditingName(false);
          
          // Refresh project details
          dispatch(fetchProjectById(params?.id))
            .unwrap()
            .then((data) => {
              setProjectDetails(data?.doc);
            });
        });
    } else {
      setIsEditingName(false);
    }
  };

  const handleCancelEditName = () => {
    setNewProjectName(projectDetails?.name || "");
    setIsEditingName(false);
  };

  return (
    <div className="flex flex-col gap-5">
      <Header />
      <div className="w-full flex justify-center items-center mt-28">
        <div className="w-[95%] flex flex-col gap-6">
          <div className="w-full bg-white px-4 py-4 flex flex-col gap-2">
            <div className="flex gap-2 items-center">
              <h1 className="text-sm font-semibold">Project Name :</h1>
              {isEditingName ? (
                <div className="flex gap-2">
                  <input
                    type="text"
                    value={newProjectName}
                    onChange={(e) => setNewProjectName(e.target.value)}
                    className="border border-gray-300 rounded px-2 py-1 text-sm"
                  />
                  <button 
                    onClick={handleSaveProjectName}
                    className="bg-green-500 text-white px-2 py-1 rounded text-xs"
                  >
                    Save
                  </button>
                  <button 
                    onClick={handleCancelEditName}
                    className="bg-gray-300 text-gray-700 px-2 py-1 rounded text-xs"
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <div className="flex gap-2 items-center">
                  <p className="text-sm">{projectDetails?.name}</p>
                  <button 
                    onClick={handleEditProjectName}
                    className="text-blue-500 hover:text-blue-700"
                  >
                    <EditIcon />
                  </button>
                </div>
              )}
            </div>
            <div className="flex gap-2">
              <h1 className="text-sm font-semibold">Client Name :</h1>
              <p className="text-sm ">{projectDetails?.client_name}</p>
            </div>

            <div className="flex gap-2">
              <h1 className="text-sm font-semibold ">
                Client Phone No :
              </h1>
              <p className="text-sm ">{projectDetails?.client_phone}</p>
            </div>

            <div className="flex gap-2">
              <h1 className="text-sm font-semibold ">Pincode :</h1>
              <p className="text-sm ">{projectDetails?.postcode}</p>
            </div>

            <div className="flex gap-2">
              <h1 className="text-sm font-semibold w-14">Notes :</h1>
              <p className="text-sm">{projectDetails?.notes}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full flex justify-center items-center mt-10">
        <div className="w-[95%] flex flex-col gap-6">
          <div className="w-full flex">
            <div className="w-[50%] flex flex-col gap-10">
              <div>
                <div className="text-2xl mb-2">
                  <p>Add Section of your house</p>
                </div>
                <form
                  className="flex gap-5"
                  onSubmit={handleSubmit(handleCreateSectionButtonClicked)}
                >
                  <TextField
                    placeholder="Section Name"
                    register={register("section_name", {
                      required: "Section is required!",
                    })}
                    errorMessage={errors.section_name?.message}
                  />
                  <Button text="Add" type="submit" className="px-14" />
                </form>
              </div>

              <AddRooms />
              <AddTouches />
            </div>

            <div className="w-[50%] pl-10">
              <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
              <div className="p-4 border border-t-0 rounded-b-lg bg-white">
                <div className="overflow-x-auto">
                  {activeTab == "Sections" && <Sections />}
                  {activeTab == "Rooms" && <Rooms />}
                  {activeTab == "Touch Switch" && <Touches />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
